module.exports = __webpack_public_path__ + "img/Lectura II.ce39cacb.png";